import React from "react";
import "../copilotSidebar/styles.css";
import moment from "moment";

const CardsSidebar = ({ isOpen, onClose, oportunidade, cards, onCardClick }) => {
  if (!isOpen) return null;

  const nomeOportunidade = oportunidade?.title || oportunidade?.nome || "Oportunidade";

  return (
    <div>
      <div className="copilot-backdrop" onClick={onClose} />

      <div className="copilot-drawer">
        {/* Header */}
        <div className="copilot-header">
          <div className="copilot-header-info">
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <h3 className="copilot-header-title">Cards Vinculados</h3>
            </div>
            <p className="copilot-header-subtitle">Cards criados a partir desta oportunidade</p>
          </div>
          <button className="copilot-close-btn" onClick={onClose} aria-label="Fechar">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="copilot-body" style={{ overflowY: 'auto' }}>
          <h2 className="copilot-client-name" style={{ marginBottom: '1rem' }}>{nomeOportunidade}</h2>

          {cards.length === 0 ? (
            <div className="text-center py-4">
              <i className="fas fa-columns fa-3x mb-3 text-muted"></i>
              <p className="text-muted">Nenhum card vinculado a esta oportunidade.</p>
            </div>
          ) : (
            <div className="cards-list" style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              {cards.map(card => (
                <div key={card.id} 
                  onClick={() => onCardClick && onCardClick(card)}
                  style={{ 
                    padding: '1rem', 
                    borderRadius: '8px', 
                    backgroundColor: '#f8f9fe',
                    border: '1px solid #e9ecef',
                    cursor: 'pointer'
                  }}
                >
                  <div style={{ fontWeight: 'bold', color: '#32325d', marginBottom: '0.25rem' }}>{card.titulo}</div>
                  <div style={{ fontSize: '0.85rem', color: '#525f7f', marginBottom: '0.5rem' }}>
                    <strong>Pipeline:</strong> {card.funil?.nome || 'N/A'}<br/>
                    <strong>Estágio:</strong> {card.estagio?.nome || 'N/A'}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span className={`badge ${card.situacao === 'aberto' ? 'badge-success' : 'badge-warning'}`} style={{ textTransform: 'capitalize' }}>
                      {card.situacao}
                    </span>
                    <span style={{ fontSize: '0.8rem', color: '#8898aa' }}>
                      {moment(card.created_at).format('DD/MM/YYYY HH:mm')}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardsSidebar;
